import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { Reviews } from '~/common/components/reviews';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.Reviews = Reviews;
// CLR alias: PortableComponent.cshtml renders ReviewsV2 blocks via this component.
global.ReviewsV2 = Reviews;
